export enum AuthErrorType {
  INTUIT_EMAIL_NOT_VERIFIED = 'INTUIT_EMAIL_NOT_VERIFIED',
  MISSING_EMAIL_IN_LOGIN_LINK = 'MISSING_EMAIL_IN_LOGIN_LINK',
  LOGIN_LINK_ERROR = 'LOGIN_LINK_ERROR',
  /**
   * The backend ran out of time while signing someone in through a magic link. Distinct from the general
   * case below because the advice differs: the user lands on a page with no attempt in progress, so what
   * they need is to open the same link again — a failed sign-in leaves it usable.
   */
  SERVICE_BUSY_LOGIN_LINK = 'SERVICE_BUSY_LOGIN_LINK',
  /**
   * Sign-in failed inside Identity Platform rather than in the browser, most often a backend that could
   * not answer within its deadline. Reached by every Firebase-native method, not only SSO, and worth
   * retrying — unlike the failure below, which never is.
   */
  SERVICE_BUSY = 'SERVICE_BUSY',
  /**
   * The sign-in blocking function could not read the account to vet an enterprise sign-in, so it refused it.
   * A failed or slow read rather than a conflict, so worth retrying.
   */
  ACCOUNT_CHECK_FAILED = 'ACCOUNT_CHECK_FAILED',
  /** The identity provider authenticated the user but released no email address, which we require. */
  NO_PROVIDER_EMAIL = 'NO_PROVIDER_EMAIL',
  /** The address already belongs to an account created through a different sign-in method. */
  ACCOUNT_EXISTS_DIFFERENT_CREDENTIAL = 'ACCOUNT_EXISTS_DIFFERENT_CREDENTIAL',
  /**
   * The organization this address belongs to signs in through a different enterprise provider than the one
   * used.
   */
  SSO_PROVIDER_MISMATCH = 'SSO_PROVIDER_MISMATCH',
  /**
   * Identity Platform refused the enterprise provider ID itself, most often because it was mistyped or belongs
   * to another environment.
   */
  ENTERPRISE_SSO_PROVIDER_REJECTED = 'ENTERPRISE_SSO_PROVIDER_REJECTED',
  /** The organization admits only its enterprise SSO provider and this session used something else. */
  ENTERPRISE_SSO_REQUIRED = 'ENTERPRISE_SSO_REQUIRED',
  /** The user's network refused the sign-in under its organization's VPC Service Controls. */
  VPCSC_CHECK_FAILED = 'VPCSC_CHECK_FAILED',
  UNKNOWN = 'UNKNOWN',
}
